const testimonials = [
  {
    name: "Jennifer K.",
    location: "Winter Garden, FL",
    rating: 5,
    text: "We booked a Disney Cruise for our family of five from Port Canaveral and I checked our passports two weeks before sailing. Both of my kids' passports had expired — one in January, one in March. I completely panicked. Fast Passport Center walked me through the child passport process, I shipped everything overnight from the UPS Store on Plant Street, and both passports arrived in four business days. We made our cruise with a day to spare. I cannot thank them enough.",
    service: "Child Passport",
  },
  {
    name: "Dr. Michael R.",
    location: "Winter Garden, FL",
    rating: 5,
    text: "I am a cardiologist who commutes from Winter Garden to Orlando Health downtown. I was invited to present at a conference in London with three weeks' notice. I pulled my passport and realized it expired two months before my return date — which meant the UK six-month rule would reject it. Fast Passport Center processed my renewal in five business days. I made the conference, gave my presentation, and even had time to explore the city. Their team understood the medical conference timeline perfectly.",
    service: "Passport Renewal",
  },
  {
    name: "Amanda T.",
    location: "Winter Garden, FL",
    rating: 5,
    text: "My daughter was accepted to a summer study abroad program in Barcelona through Valencia College. She received her acceptance letter with five weeks until departure and had never had a passport before. We had no idea about the acceptance clerk requirement for first-time applicants. Fast Passport Center guided us to the Ocoee Post Office for her appointment, reviewed all her documents before we shipped them, and her passport arrived in six business days. She is in Barcelona right now having the time of her life.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WinterGardenTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Winter Garden Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Winter Garden families, medical professionals, students, and business travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}